import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CustomerSearchComponent } from './customer-search/customer-search.component'
import { CreateSessionComponent } from './create-session/create-session.component';
import { ContactViewComponent } from './contact-view/contact-view.component';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { CustomerAgeingComponent } from './customer-ageing/customer-ageing.component';
import { MatButtonModule } from '@angular/material/button';
import { ContactConsigneeComponent } from './contact-consignee/contact-consignee.component';
import { PipesModule } from '../../Pipes/pipes.module';
import { OpsDetailsComponent } from './ops-details/ops-details.component';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatPseudoCheckboxModule } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { ServiceModule } from '../../Services/service.module';
import { OpsPartSerachComponent } from './ops-part-serach/ops-part-serach.component';
import { ProductSearchComponent } from './product-search/product-search.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OpsPaymentTermsComponent } from './ops-payment-terms/ops-payment-terms.component';
import { OpsListComponent } from './ops-list/ops-list.component';
import { SpraApprovalComponent } from './spra-approval/spra-approval.component';
import { SpraPriceJustificationComponent } from './spra-price-justification/spra-price-justification.component';
import { SpraNetSalePriceRealisedComponent } from './spra-net-sale-price-realised/spra-net-sale-price-realised.component';
import { SpraCompetitionDetailComponent } from './spra-competition-detail/spra-competition-detail.component';
import { SpraAmcvComponent } from './spra-amcv/spra-amcv.component';
import { ToastrModule } from 'ngx-toastr';
import { SpraApprovalRemarksComponent } from './spra-approval-remarks/spra-approval-remarks.component';
import { SpraCompetitionCsaRateComponent } from './spra-competition-csa-rate/spra-competition-csa-rate.component';
import { SpraValidationHierarchyComponent } from './spra-validation-hierarchy/spra-validation-hierarchy.component';
import { SpraListComponent } from './spra-list/spra-list.component';
import { MultipleFileUploadComponent } from './multiple-file-upload/multiple-file-upload.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { SpraConsigneeComponent } from './spra-consignee/spra-consignee.component';
import { SpraAmcvRentalComponent } from './spra-amcv-rental/spra-amcv-rental.component';
import { SpraRentalEmiComponent } from './spra-rental-emi/spra-rental-emi.component';
import { SpraRentalPLComponent } from './spra-rental-pl/spra-rental-pl.component';
import { SpraConsumableBillingDetailComponent } from './spra-consumable-billing-detail/spra-consumable-billing-detail.component';
import { SpraDiscountViewComponent } from './spra-discount-view/spra-discount-view.component';
import { SpraViewConsigneeComponent } from './spra-view-consignee/spra-view-consignee.component';
import { SpraNotionalInputComponent } from './spra-notional-input/spra-notional-input.component';
import { RemoveSessionComponent } from './remove-session/remove-session.component';


@NgModule({
  declarations: [
    CustomerSearchComponent,
    CreateSessionComponent,
    ContactViewComponent,
    ProductSearchComponent,
    CustomerAgeingComponent,
    ContactConsigneeComponent,
    OpsDetailsComponent,
    OpsPartSerachComponent,
    OpsPaymentTermsComponent,
    OpsListComponent,
    SpraApprovalComponent,
    SpraPriceJustificationComponent,
    SpraNetSalePriceRealisedComponent,
    SpraCompetitionDetailComponent,
    SpraAmcvComponent,
    SpraApprovalRemarksComponent,
    SpraCompetitionCsaRateComponent,
    SpraValidationHierarchyComponent,
    SpraListComponent,
    MultipleFileUploadComponent,
    ConfirmationDialogComponent,
    SpraConsigneeComponent,
    SpraAmcvRentalComponent,
    SpraRentalEmiComponent,
    SpraRentalPLComponent,
    SpraConsumableBillingDetailComponent,
    SpraDiscountViewComponent,
    SpraViewConsigneeComponent,
    SpraNotionalInputComponent,
    RemoveSessionComponent
  ],
  imports: [
    /* -- Core Angular Modules --*/
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    BrowserModule,
    NgbModule,
    /* -- Angular Material Modules --*/
    MatInputModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatRadioModule,
    NgSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatExpansionModule,
    MatCheckboxModule ,
    MatIconModule, 

    /*-- User Define Modules--*/
    ServiceModule.forRoot(),
    PipesModule.forRoot(),
    ToastrModule.forRoot(),

  ],
  exports: [
    CustomerSearchComponent,
    CreateSessionComponent,
    ContactViewComponent,
    ProductSearchComponent,
    CustomerAgeingComponent,
    ContactConsigneeComponent,
    OpsDetailsComponent,
    OpsPartSerachComponent,
    OpsPaymentTermsComponent,
    OpsListComponent,
    SpraApprovalComponent,
    SpraNetSalePriceRealisedComponent,
    SpraPriceJustificationComponent,
    SpraCompetitionDetailComponent,
    SpraAmcvComponent,
    SpraCompetitionCsaRateComponent,
    MultipleFileUploadComponent,
    PipesModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    NgbModule,
    NgSelectModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatIconModule,
    ToastrModule,
    SpraApprovalRemarksComponent,
    ConfirmationDialogComponent,
    SpraConsigneeComponent,
    SpraAmcvRentalComponent,
    SpraRentalEmiComponent,
    SpraRentalPLComponent,
    SpraConsumableBillingDetailComponent,
    SpraDiscountViewComponent,
    SpraViewConsigneeComponent,
    RemoveSessionComponent,
    SpraNotionalInputComponent
  ],
  entryComponents: [
    OpsListComponent,
    SpraCompetitionCsaRateComponent,
    ConfirmationDialogComponent,
    SpraConsigneeComponent,
    SpraRentalEmiComponent,   
    SpraRentalPLComponent
  ]
})
export class MastersModule {
  static forRoot(): ModuleWithProviders<MastersModule> {
    return {
      ngModule: MastersModule
    }
  }
}
